import { create } from 'zustand'
import { initialStore } from './InitialValues'

const useStore = create(set => ({
  name: '',
  city: '',
  address: '',
  state: '',
  postalCode: '',
  country: '',
  rawCategory: '',
  primaryCategories: ['Any'],
  isQueryLoading: false,
  queryStore: '',
  dataResults: [],
  downloadData: {
    downloadQueryStore: '',
    download_id: ''
  },
  recordRecency: {
    dateAdded: '',
    dateUpdated: ''
  },
  featureKeyword: {
    key: '',
    value: ''
  },
  description: {
    value: ''
  },
  requiredFields: [],
  reviews: {
    value: ''
  },
  menus: {
    value: ''
  },
  geoLocation: {
    value: ''
  },
  reviewsRangeQuery: { // New field for reviews range
    min: "",
    max: ""
  },
  reviewsByDate: {
  start: '',
  end: ''
  },
  firstRender: true,
  page: 1,
  shouldRefetch: false,

  // Setters
  setName: setName => set(() => ({ name: setName })),
  setCountry: newCountry => set(() => ({ country: newCountry })),
  setRawCategory: newRawCategory => set(() => ({ rawCategory: newRawCategory })),
  setIsQueryLoading: loading => set(() => ({ isQueryLoading: loading })),
  setPrimaryCategories: newCategories => set(() => ({ primaryCategories: newCategories })),
  setRequiredFields: newRequiredFields => set(() => ({ requiredFields: newRequiredFields })),
  setReviewsByDate: ({ start, end }) =>
  set(() => ({
    reviewsByDate: { start, end }
  })),
  setQueryStore: newQuery => set(() => ({ queryStore: newQuery })),
  setDataResults: newData => set(() => ({ dataResults: newData })),
  setDownloadQueryStore: ({ query, id }) =>
    set(state => ({
      downloadData: {
        ...state.downloadData,
        downloadQueryStore: query,
        download_id: id
      }
    })),
  setFirstRender: value => set(() => ({ firstRender: value })),
  setPage: newPage => set(() => ({ page: newPage })),
  resetStore: () => set(() => ({ ...initialStore, firstRender: true })),

  setAddress: newAddress => set(() => ({ address: newAddress })),
  setCity: newCity => set(() => ({ city: newCity })),
  setState: newState => set(() => ({ state: newState })),
  setPostalCode: newPostalCode => set(() => ({ postalCode: newPostalCode })),
  setShouldRefetch: (value) => set(() => ({ shouldRefetch: value })),

  setRecordRecency: updates =>
    set(state => ({
      recordRecency: {
        ...state.recordRecency,
        ...updates
      }
    })),

  setFeatureKeyword: updates =>
    set(state => ({
      featureKeyword: {
        ...state.featureKeyword,
        ...updates
      }
    })),

  setDescription: updates =>
    set(state => ({
      description: {
        ...state.description,
        ...updates
      }
    })),

  setReviews: newReviews =>
    set(() => ({
      reviews: {
        value: newReviews
      }
    })),

  setMenus: newMenus =>
    set(() => ({
      menus: {
        value: newMenus
      }
    })),

  setGeoLocationBusiness: newGeoLocation =>
    set(() => ({
      geoLocation: {
        value: newGeoLocation
      }
    })),

  setReviewsRangeQuery: ({ min, max }) => // Setter for reviews range
    set(() => ({
      reviewsRangeQuery: { min, max }
    }))
}))

export default useStore
